// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2LW-O","title":"InfoRow_title__1SWNZ"};